import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  failed: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("FlavorCraft render failure", error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="fatal-error">
          <p className="eyebrow">The counter needs a reset</p>
          <h1>FlavorCraft could not finish this view.</h1>
          <p>Your selections live in the address bar. Reloading is safe.</p>
          <button
            className="primary-button"
            onClick={() => window.location.reload()}
          >
            Reload the app
          </button>
        </main>
      );
    }
    return this.props.children;
  }
}
